export default __webpack_public_path__ + "img/db6ca880a5f27a1f2ccb3aab82c7c4f5.svg";